import { SurveyAccomplishPage } from './../survey-accomplish/survey-accomplish';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the SurveyMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-survey-menu',
  templateUrl: 'survey-menu.html',
})
export class SurveyMenuPage {

  private previousPage: SurveyAccomplishPage;
  
  public slideCount: number;
  public demographicDisabled: boolean;
  public surveyDisabled: boolean;
  public conclusionDisabled: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    
  }

  ngOnInit() {
    if (this.navParams.data) {
      this.previousPage = this.navParams.data.page;
      this.slideCount = this.navParams.data.slideCount;
      this.demographicDisabled = this.navParams.data.demographicDisabled;
      this.surveyDisabled = this.navParams.data.surveyDisabled;
      this.conclusionDisabled = this.navParams.data.conclusionDisabled;
    }
  }

  change(slide: number) {
    this.previousPage.goToSlide(slide);
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/survey-menu/survey-menu.ts